import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { TuiButton, TuiButtonX, TuiIcon } from '@taiga-ui/core';
import { TuiCardLarge } from '@taiga-ui/layout';
import { WoundsizeTutorialService } from '../../services/woundsize-tutorial.service';

@Component({
  selector: 'pxc-woundsize-tutorial',
  imports: [TuiIcon, TuiButton, TuiButtonX, TuiCardLarge, TranslocoDirective],
  host: {
    class: 'absolute left-4 top-20',
  },
  templateUrl: './woundsize-tutorial.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WoundsizeTutorialComponent {
  readonly tutorialService = inject(WoundsizeTutorialService);
}
